import { store, reviewStore, categoryStore } from '@/store';
import { routeMixin } from './route';

import { ADBLOCK_EXOCLICK, TRAFFIC_SOURCE_EXOCLICK } from '@/constants';

export const comparisonMixin = {
    data() {
        return {
            comparison: [],
            reviewState: reviewStore.state,
            loaded: false,
            partners: [],
            propNames: [],
            maxPartners: null,
        };
    },
    mixins: [routeMixin],
    beforeMount() {
        this.getComparison();
        if (window.track) {
            window.track.pageview(`/comparison`);
        } else {
            this.$ga.page(`/comparison`);
        }
    },
    methods: {
        getTrafficSource() {
            let trafficSource = this.$globalState.trafficSource;

            if (TRAFFIC_SOURCE_EXOCLICK === trafficSource) {
                trafficSource = ADBLOCK_EXOCLICK;
            }

            return trafficSource;
        },
        async getComparison() {
            const trafficSource = this.getTrafficSource();
            const category = this.getCategorySlug();
            const uT = this.$globalConstants.user?.userTimezone || '1';
            const boostRankingVersion = this.$route.query.brnkv || '';
            const boostRanking = this.$route.query.brnk ? '1' : '';
            const clId = this.$globalConstants.clickinId || '';
            const uA = this.$globalConstants.user?.age || '';
            const uG = this.$globalConstants.user?.gender || '';
            const userToken = window.__token__;
            const hasAbRank = !!this.$route.query.arnk;
            const fixedPosition = this.$globalState.fixedPosition;
            const hostId = this.$globalConstants.host.id;

            let url = `/host/${hostId}/category/${trafficSource}/${category}?arnk=${hasAbRank}&fp=${fixedPosition}&t=${userToken}&uT=${uT}&brnkv=${boostRankingVersion}&brnk=${boostRanking}&clId=${clId}&uA=${uA}&uG=${uG}`;
            url = url + '&device_type=' + this.$globalConstants.deviceType;

            const comparisonUrl = `/host/${hostId}/comparison?device_type=${this.$globalConstants.deviceType}&category=${category}&traffic_source=${trafficSource}&t=${userToken}&clId=${clId}&uA=${uA}&uG=${uG}`;

            if (this.$route.path === '/comparison') {
                await window.axios.get(url).then((response) => {
                    this.psh = response.data.partnerSet;
                    store.setPsh(response.data.partnerSet);
                    store.setPageViewId(response.data.page_view_id);
                    categoryStore.updateRankingList(response.data.partners);
                    this.partners = response.data.partners;
                    if (!this.reviewState.reviewPartners) {
                        reviewStore.setReviewPartners(
                            response.data.partners_review
                        );
                    }
                    this.loaded = true;
                });
            }
            await window.axios.get(comparisonUrl).then((response) => {
                this.loaded = true;
                this.comparison = response.data;

                try {
                    document.title =
                        this.$globalConstants.host['compare_title'];
                    document
                        .querySelector('head meta[name="description"]')
                        .setAttribute(
                            'content',
                            this.$globalConstants.host['compare_description']
                        );
                } catch (e) {
                    console.log(e);
                }
            });
        },
        getPartnerProps(id) {
            return this.comparison['partnerProperties'][id];
        },
    },
};
